module.exports = __webpack_public_path__ + "img/7.ab448815.png";